




































































import Vue from 'vue';
import {UserRole} from '@/types/user-role';
import {UserClass} from '@/types/userClass';

export default Vue.extend({
  name: 'UserForm',
  props: {
    dialog: Boolean
  },
  data: () => ({
    valid: false,
    confirmPassword: '',
    passwordRules: [
      (v: string) => !!v || 'Обязательное поле',
    ],
    loginRules: [
      (v: string) => !!v || 'Обязательное поле'
    ],
    emailRules: [
      (v: string) => !!v || 'Обязательное поле',
      (v: string) => /.+@.+\..+/.test(v) || 'Введите валидный E-mail'
    ],
    roles: [
      {text: 'пользователь', value: UserRole.USER},
      {text: 'администратор', value: UserRole.ADMIN}
    ],
    user: new UserClass()
  }),
  methods: {
    validate() {
      (this.$refs.form as any).validate();
      if (this.user.password !== this.confirmPassword) {
        this.valid = false
      }
    },
    submit() {
      this.validate();
      if (this.valid) {
        this.$emit('addUser', this.user);
      }
    },
    reset() {
      this.$emit('reset')
    }
  }
});
